<template>
  <div class="totalbox">
    <div class="listbox" v-if="notEmpty(this.discounts)">
      <div class="row" v-for="(item, idx) in this.discounts">
        <p class="label">{{ item.title }}</p>
        <p class="contxt green onerow">{{ item.format }}</p>
      </div>
    </div>
    <div class="listbox" v-if="1 || ftotal.price >= 0">
      <div class="row price-emphasis">
        <p class="label">Final Price</p>
        <p class="contxt onerow">{{ ftotal.format }}</p>
      </div>
      <div class="row" v-if="userStore.user.customerGroupId==1 && policyPoints > 0">
        <p class="contxt">You will earn {{ policyPoints }} Points for this booking and payment.</p>
      </div>
      <div class="row" v-else-if="userStore.user.customerGroupId==3 && (agentComm??'')!='' ">
        <div class="label">Commission</div>
        <div class="contxt onerow">{{ agentComm }}</div>
      </div>
    </div>

    <div class="listbox" v-if="odata.isFlight == 0 || offerSelected > 0">
      <template v-for="(item, idx) in depinfo">
        <div
          :class="'row ' + (isBalanceDueRow(item) ? 'balance-due-row' : 'price-emphasis') + (0 == idx ? ' total' : '')"
          v-if="Object.keys(item).length > 0"
        >
          <p class="label">{{ item.title }} {{ item.payment_date }}</p>
          <p class="contxt onerow">{{ item.price_format }}</p>
        </div>
        <div v-if="item.explain != ''" class="row">
          <p class="label">{{ item.explain }}</p>
        </div>
        <div class="listbox" v-if="item.policy">
          <p class="contxt click">
            <span @click="policyEvent"
              >Click
              <img
                src="/images/flight/icon_tipinfo.png"
                class="ico"
                alt=""
                style="vertical-align: middle"
            /></span>
            to check the land portion policy
          </p>
          <p class="contxt click" v-for="(optpolicy, optpidx) in opt_policy_deposit.policy">
            <span @click="optPolicyEvent(optpolicy)"
              >Click
              <img
                src="/images/flight/icon_tipinfo.png"
                class="ico"
                alt=""
                style="vertical-align: middle"
            /></span>
            to check the {{ optpolicy.optname }} portion policy
          </p>
        </div>
      </template>
    </div>
  </div>
  <div class="prop" v-if="policy.status" style="" @click="policy.status = false">
    <div class="con airfaretipscon" id="airfaretipscon" @click.stop>
      <div class="closer fixed_closer" @click="policy.status = false">
        <img src="/images/icon_close.png" />
      </div>

      <div class="pop_con" id="airfaretipscon2">
        <div class="policy_title">Operator Policy</div>
        <div style="margin: 3rem 1rem; margin-top: 1rem">
          Cancellation fees will be applied based on the date the written cancellation is received
          and the following days before departure. Fees will be calculated as a percentage of the
          total amount received. Cancellation fees will not be less than the initial non-refundable
          deposit.
        </div>
        <div style="margin: 3rem 1rem">
          Cancellation Fees for all tour reservations, except where specified:
        </div>

        <div style="margin: 3rem 1rem" v-if="tripRefundRule.list.length > 0">
          <p v-for="(ritem, ridx) in tripRefundRule.list">
            {{
              ritem.inv +
              ' ' +
              (ritem.atype == 1
                ? ritem.amount + '%'
                : (ritem.amount != 0 || ritem.category != 1 ? pFormat(ritem.amount, 2, 1) : '') +
                  ' per person')
            }}
          </p>
        </div>
        <div class="" style="margin: 1rem 1rem; margin-bottom: 0rem">
          <!-- Check details of  --><span style="color: #1b80de" @click="showDetail()"
            >View Full {{ productPolicyName }}</span
          >
        </div>
        <div class="" v-if="showProductPolicy">
          <div class="block product_policy">
            <div class="r product_policy_detail" style="padding: 0; margin: 0">
              <div v-html="productPolicy"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="prop" v-if="optionPolicy.status" style="" @click="optionPolicy.status = false">
    <div class="con airfaretipscon" id="airfaretipscon" @click.stop>
      <div class="closer fixed_closer" @click="optionPolicy.status = false">
        <img src="/images/icon_close.png" />
      </div>

      <div class="pop_con" id="airfaretipscon2">
        <div class="policy_title">{{ optionPolicy.name }} Operator Policy</div>
        <div
          style="margin: 3rem 1rem; margin-top: 1rem"
          v-html="formatContent(optionPolicy.text)"
        ></div>
        <div class="" style="margin: 1rem 1rem; margin-bottom: 0rem">
          <span style="color: #1b80de" @click="showOptDetail()"
            >View Full {{ productPolicyName }}</span
          >
        </div>
        <div class="" v-if="showOptProductPolicy">
          <div class="block product_policy">
            <div class="r product_policy_detail" style="padding: 0; margin: 0">
              <div v-html="productPolicy"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { notEmpty, priceFormat, priceAmount, isNull } from '@/utils/tool.js'
import Request from '@/services/Request.ts'
import { useInsuranceStore } from '@/stores/InsuranceStore'
import { useUserStore } from '@/stores/UserStore'
import { useCurrencyStore } from '@/stores/CurrencyStore'
import { localDriver } from '@/utils/localDriver'

export default {
  // chargeAmount: { amount, currency } the payment gateway charges today for the selected payment type.
  props: ['step', 'refidx', 'flyOffer', 'offerSelected', 'priceSummary', 'rmkey', 'odkey','agentComm','selectedPaymentType','chargeAmount'],
  setup() {
    return {
      insuranceStore: useInsuranceStore(),
      userStore: useUserStore()
    }
  },
  data() {
    return {
      isNull,
      notEmpty,
      priceFormat,
      ismobile: false,
      depinfo: {},
      odata: {},
      flyamt: 0,
      persons: 0,
      ftotal: {
        price: 0,
        format: ''
      },
      policy: { text: '', list: [], status: false },
      optionPolicy: { text: '', name: '', status: false },
      tripRefundRule: { list: [], status: 1 },
      showProductPolicy: false,
      showOptProductPolicy: false,
      productPolicy: '',
      productPolicyName: '',
      policyPoints: 0,
      clicked: 0,
      discounts: [],
      opt_policy_deposit: { common: 0, policy: [] },
      cachedRecurring: null,
    }
  },
  watch: {
    priceSummary: {
      handler(newValue, oldValue) {
        //console.log('------------------------payment summary---11--', newValue);
        this.getDeposit(newValue.totals.price)
      },
      deep: true
    },
    offerSelected: {
      handler(newValue, oldValue) {
        //console.log('------------------------payment summary---11--', newValue);
        if (!isNull(this.priceSummary)) {
          this.getDeposit(this.priceSummary.totals.price)
        }
      },
      deep: true
    },
    selectedPaymentType: {
      handler() {
        if (!isNull(this.priceSummary)) {
          this.getDeposit(this.priceSummary.totals.price)
        }
      },
      deep: true
    },
    chargeAmount: {
      handler() {
        if (!isNull(this.priceSummary)) {
          this.getDeposit(this.priceSummary.totals.price)
        }
      },
      deep: true
    },
    refidx: {
      handler() {
        if (this.priceSummary?.totals) {
          this.getDeposit(this.priceSummary.totals.price)
        }
      }
    }
  },
  async mounted() {
    if (document.documentElement.clientWidth < 750) {
      this.ismobile = true
    } else {
      this.ismobile = false
    }
    let odata = await localDriver.getItem(this.odkey)
    this.povOptions = this.getPovOptions(odata.oriOptions)
    await this.getRecurring(odata)
    await this.getDeposit(notEmpty(this.priceSummary.totals) ? this.priceSummary.totals.price : 0)
    if (odata) {
      let product_id = odata.product_id
      this.getProductPolicy(product_id)
    } 
  },
  methods: {
    formatContent(content) {
      // Validate content parameter
      if (!content || typeof content !== 'string') {
        return ''
      }

      var cleanedHtmlContent = content.replace(
        /style="[^"]*?(line-height|height|margin-top|margin-bottom):[^;"]*;?[^"]*"/g,
        function (style) {
          return style
            .replace(/(line-height|height|margin-top|margin-bottom):[^;"]*;?/g, '')
            .replace(/style=";?/, 'style="')
            .replace(/style=""/, '')
        }
      )
      cleanedHtmlContent = cleanedHtmlContent.replace(/font-size: 14px;/g, 'font-size: 1.5167rem;')
      return cleanedHtmlContent
    },
    getPovOptions(opts) {
      let res = []
      if (notEmpty(opts)) {
        for (let i in opts) {
          for (let j in opts[i].product_option_value) {
            res[opts[i].product_option_value[j].product_option_value_id] =
              opts[i].product_option_value[j]
          }
        }
      }

      return res
    },
    showOptDetail() {
      this.showOptProductPolicy = !this.showOptProductPolicy
      if (this.showOptProductPolicy) {
        console.log('detail')
        this.clicked++
        if (this.clicked < 3) {
          console.log('detail3')
          setTimeout(function () {
            var div = document.getElementById('airfaretipscon')
            div.scrollTop = div.scrollTop + 200
            console.log('1000')
          }, 1000) // 延迟 1000 毫秒，也就是 1 秒
        }
      } else {
        /*  setTimeout(function() {
           var div = document.getElementById('airfaretipscon');
           div.scrollTop =div.scrollTop - 100; 
       }, 500); // 延迟 1000 毫秒，也就是 1 秒
        */
      }
    },
    showDetail() {
      this.showProductPolicy = !this.showProductPolicy
      console.log(' 222')
      if (this.showProductPolicy) {
        console.log('detail2')
        this.clicked++
        if (this.clicked < 3) {
          console.log('detailaa3')
          setTimeout(function () {
            var div = document.getElementById('airfaretipscon2')
            console.log('detail3')
            div.scrollTop = div.scrollTop + 300
          }, 800) // 延迟 1000 毫秒，也就是 1 秒
        }
      } else {
        /*  setTimeout(function() {
           var div = document.getElementById('airfaretipscon');
           div.scrollTop =div.scrollTop - 100; 
       }, 500); // 延迟 1000 毫秒，也就是 1 秒
        */
      }
    },
    getProductPolicy(produt_id) {
      new Request().webGet(
        {},
        (res) => {
          //console.log("---getProductPolicy---", res);
          if (res.success) {
            this.productPolicy = res.data.description
            this.productPolicyName = res.data.name.split('@')[0]
          }
        },
        'product/common/getPolicy&product_id=' + produt_id + '&display_currency=' + encodeURIComponent(this.odata?.currency || '')
      )
    },
    optPolicyEvent(optpolicy) {
      this.optionPolicy.status = true
      this.optionPolicy.name = optpolicy.optname
      this.optionPolicy.text = this.povOptions[optpolicy.povid].desc
    },
    policyEvent() {
      this.policy.status = true
    },
    pFormat(val, d = 2, t = 0) {
      return priceFormat(this.odata.currency, val, ',', d, t)
    },
    async initdata() {
      this.odata = await localDriver.getItem(this.odkey)
      if (!this.odata) return
      let roomlist = await localDriver.getItem(this.rmkey)
      this.persons = 0
      for (var i in roomlist) {
        this.persons += parseInt(roomlist[i].Adults) + parseInt(roomlist[i].Child)
      }
      this.initRefundRule()
    },
    getElementCount(variable) {
      let cnt = 0
      if (Array.isArray(variable)) {
        cnt = variable.length
      } else if (typeof variable === 'object' && variable !== null) {
        cnt = Object.keys(variable).length
      }
      return cnt
    },
    isBalanceDueRow(item) {
      return String(item?.title || '').trim() === 'Balance Due'
    },
    getSelectedPaymentType() {
      return String(this.selectedPaymentType || '').trim().toLowerCase()
    },
    initRefundRule() {
      //console.log('----------tripRefundRule----------',this.odata);
      if (this.odata.product_id > 0 && this.tripRefundRule.status > 0) {
        new Request().webPost(
          // refund_display_currency: the page currency (odata.currency here). The backend converts the fixed rule
          // amounts and the amounts typed in the rule text from the product currency; without it, raw rules.
          { product_id: this.odata.product_id, refund_display_currency: this.odata.currency || '' },
          (res) => {
            //console.log('----------tripRefundRule----------',res);
            this.tripRefundRule.list = res.data
            this.tripRefundRule.status = 0
          },
          'product/product/trip_refund_rule'
        )
      }
    },
    getDiscounts(sum) {
      let discounts = []
      if (this.step >= 4) {
        let discountprice = 0;

        for (let i in this.odata.totals) {
          if (this.odata.totals[i].code.includes('coupon')) {
            discountprice = priceAmount(this.odata.totals[i].text, 2)
            const isGrouponCode = String(this.odata.totals[i].title || '').includes('Groupon code')
            if(!isGrouponCode && Math.abs(discountprice) > sum)
            {
              discountprice = -sum
            }
            sum += discountprice
            discounts.push({
              title: this.odata.totals[i].title,
              price: discountprice,
              format: priceFormat(this.odata.currency, discountprice, ',', 2, 1),
              type: this.odata.totals[i]?.type??0,
            })
          } else if ('credit' == this.odata.totals[i].code.toLowerCase()) {
            discountprice = priceAmount(this.odata.totals[i].text, 2)
            sum += discountprice
            discounts.push({
              title: 'Points',
              price: discountprice,
              format: priceFormat(this.odata.currency, discountprice, ',', 2, 1),
              type: this.odata.totals[i]?.type??0,
            })
          }
        }
      }
      this.discounts = discounts
      return sum
    },
    async getRecurring(odata) {
      return new Promise((resolve, reject) => {
        new Request().webPost(
          {
            product_id: odata.product_id,
            depart_date: odata.depart_date,
            trip_type: odata.trip_type,
            currency: odata.currency ?? 'USD',
          },
          async (res) => {
            try {
              const recurringData = res && res.success && res.data ? res.data : []
              odata = { ...odata, recurring: recurringData }
              this.cachedRecurring = recurringData
              await localDriver.setItem(this.odkey, odata)
              resolve(res.data)
            } catch (err) {
              reject(err)
            }
          },
          'product/product_trip/getDeposit'
        )
      })
    },
    async getDeposit(oTotal) {
      await this.initdata()
      if (!this.odata) return

      // Apply discounts to total price (trip + options) for Final Price display
      let totalWithDiscounts = this.getDiscounts(oTotal)

      // Get trip/land portion price only (excluding options) for trip deposit calculation
      // Options have separate deposit calculation and should NOT be included in trip deposit base
      // Insurance and flight are paid in full and should NOT be included in the trip deposit percentage base
      let landTotal = notEmpty(this.priceSummary) && notEmpty(this.priceSummary.roomprice)
        ? parseFloat(this.priceSummary.roomprice.price)
        : totalWithDiscounts

      // CRITICAL FIX: For FP packages, roomprice includes flight component
      // Subtract flight price (cityprice) to get land-only price for deposit calculation
      if (this.odata.product_info.model.toUpperCase().slice(0, 3) == 'FP-') {
        landTotal -= parseFloat(this.odata.cityprice) * this.persons
      }

      let insurance_payment =
        notEmpty(this.priceSummary) && notEmpty(this.priceSummary.insurance)
          ? this.priceSummary.insurance.price
          : 0

      // oTotal is used for Final Price display (includes trip + options + insurance + flight - discounts)
      oTotal = totalWithDiscounts + insurance_payment
      let depostTxt = []
      this.ftotal = {
        price: oTotal,
        format: priceFormat(this.odata.currency, 0, ',', 2, 1)
      }      
      //if (oTotal > 0) 
      {
        oTotal = parseFloat(oTotal)
        var deposit = {}
        var secondpayment = {}
        var finalpayment = {}

        var beforedate = 120
        var price = 0
        var rs = this.odata.recurring || this.cachedRecurring

        let explainTxt = 'At the time of booking, you will pay '
        if (
          this.odata.product_info.model.toUpperCase().slice(0, 3) !== 'FP-' &&
          this.odata.isFlight > 0
        ) {
          ///('flightOffer' in this.odata))
          if (this.offerSelected <= 0) {
            this.flyamt =
              (this.odata.cityprice +
                (notEmpty(this.flyOffer) ? parseFloat(this.flyOffer.price) : 0)) *
              this.persons
          } else {
            this.flyamt =
              (('flightOffer' in this.odata ? parseFloat(this.odata.flightOffer.price) : 0) +
                parseFloat(this.odata.cityprice)) *
              this.persons
          }
          
          oTotal += this.flyamt
          if(oTotal < 0){
            oTotal = 0;
            this.flyamt = 0;
          }
        }        
        let finalprice = oTotal
        this.ftotal = {
          price: oTotal,
          format: priceFormat(this.odata.currency, oTotal, ',', 2, 1)
        }

        const memberTypeId = parseInt(this.userStore?.user?.memberType ?? 0)
        // membershiptype_id 10 = Discoverer (free tier, no rewards points)
        this.policyPoints =
            memberTypeId > 0 && memberTypeId !== 10
              ? (oTotal * (memberTypeId + 1) * 0.005).toFixed(2)
              : 0
        this.opt_policy_deposit = { common: 0, policy: [] }

        //console.log('------------------rs-------------',rs)
        if (rs) {
          let opt_deposit = 0
          let optPax = []
          if (this.step > 1) {
            for (var ridx in rs.option) {
              if (
                notEmpty(this.odata.options) &&
                ridx + '' in this.odata.options &&
                this.odata.options[ridx + ''].length > 0
              ) {
                // Calculate option deposit amount
                let optRate = parseFloat(rs.option[ridx].rate) || 0
                let optStatus = rs.option[ridx].status !== undefined ? parseInt(rs.option[ridx].status) : 1
                let optAmt =
                  this.odata.options[ridx].length *
                  (rs.option[ridx].type == 1
                    ? (parseFloat(rs.option[ridx].option_price) * optRate) / 100
                    : optRate)

                // Only add to deposit if rate > 0, status is active (not closed), and policy is active
                // Closed options have rate=0 or status=0, so they won't be included
                if (optRate > 0 && optStatus > 0 && optAmt > 0) {
                  opt_deposit += optAmt
                }

                // Only show option deposit in policy list if amount is greater than 0 and status is active
                if (rs.option[ridx].option_policy > 0 && optAmt > 0 && optRate > 0 && optStatus > 0) {
                  this.opt_policy_deposit.policy.push({
                    povid: ridx,
                    amt: optAmt,
                    qty: this.odata.options[ridx].length,
                    optname: this.povOptions[ridx].name
                  })
                } else if (optAmt > 0 && optRate > 0 && optStatus > 0) {
                  this.opt_policy_deposit.common += optAmt
                  for (let t of this.odata.options[ridx]) {
                    if (!optPax.includes(t)) {
                      optPax.push(t)
                    }
                  }
                }
              }
            }
          }
          for (var ridx in rs.trip) {
            if (1 == ridx)
            {
              // Calculate trip deposit based on land portion only (excluding insurance and flight)
              // IMPORTANT: When travelers have different prices, calculate deposit for each price tier separately
              // This ensures accurate per-person deposits instead of averaging
              let trip_depost = 0
              let isFP = this.odata.product_info.model.toUpperCase().slice(0, 3) === 'FP-'                  
              let cityprice = isFP ? parseFloat(this.odata.cityprice) : 0
              if (rs.trip[1].type == 1) 
              {
                // Percentage-based deposit: calculate for each price tier in roompriceDetails
                if (notEmpty(this.priceSummary) && notEmpty(this.priceSummary.roompriceDetails)) {
                  // Use roompriceDetails to calculate deposit for each different price
                  for (let detail of this.priceSummary.roompriceDetails) {
                    if (detail.title !== 'Solo Occupancy') {
                      let landPrice = detail.price - cityprice
                      trip_depost += (landPrice * detail.qty * rs.trip[1].rate) / 100
                    }
                  }
                } else {
                  // Fallback to landTotal if roompriceDetails not available
                  trip_depost = (landTotal * rs.trip[1].rate) / 100
                }
              } else {
                // Fixed amount deposit: multiply rate by number of persons. The rule is set in the product
                // currency, so convert it to the page currency the customer pays in.
                trip_depost = rs.trip[1].rate * this.persons * this.depositCurrencyRate()
              }
              price = this.tripDeposit(trip_depost,opt_deposit,cityprice*this.persons)
              let fly_deposit = 0

              if (this.odata.isFlight > 0) {
                if (
                  notEmpty(this.odata.flightOffer) &&
                  notEmpty(this.odata.flightOffer.deposit) &&
                  (this.odata.flightOffer.deposit > 0 || this.odata.flightOffer.rid == 0)
                ) {
                  explainTxt = 'Your deposit covers the following:'
                  fly_deposit = parseFloat(this.odata.flightOffer.deposit)
                  let discountGroupon = 0;
                  for(let dc of this.discounts){
                     if(dc.title.includes('Groupon')){
                        discountGroupon += (parseFloat(dc.price) + parseFloat(this.odata.prices_info[this.odata.depart_date].price))
                     }
                  }
                  fly_deposit += discountGroupon;
                  fly_deposit = fly_deposit>0?fly_deposit:0;
                  price += fly_deposit                  
                  if(fly_deposit > 0 || this.odata.flightOffer.rid == 0) 
                  {
                    depostTxt.push(
                      ' a ' +
                        priceFormat(this.odata.currency, fly_deposit / this.persons, ',', 2, 1) +
                        '  per person deposit for the flight portion (including taxes and fees)'
                    )
                  }
                } else {
                  fly_deposit =
                    this.odata.flights_amount > 0
                      ? parseFloat(this.odata.flights_amount)
                      : parseFloat(this.odata.cityprice) * this.persons
                  let discountGroupon = 0;
                  for(let dc of this.discounts){
                     if(dc.title.includes('Groupon')){
                        discountGroupon += (parseFloat(dc.price) + parseFloat(this.odata.prices_info[this.odata.depart_date].price))
                     }                     
                  }
                  fly_deposit += discountGroupon;
                  fly_deposit = fly_deposit>0?fly_deposit:0;
                  price += fly_deposit
                  if (fly_deposit > 0) {
                    depostTxt.push(
                      ' a ' +
                        priceFormat(this.odata.currency, fly_deposit / this.persons, ',', 2, 1) +
                        ' per-person for airfare (including taxes and fees)'
                    )
                  }
                }
              }
              //let insurance_payment = (notEmpty(this.priceSummary) && notEmpty(this.priceSummary.insurance))?this.priceSummary.insurance.price:0;
              // let insurance_payment = this.insuranceStore.unPay
              price += insurance_payment
              if (insurance_payment > 0) {
                //a $XXX.00 total for xx travelers’ protection plan (including taxes and fees),
                let insurancePax = 0
                for (let c of this.insuranceStore.quoteInfo.customers) {
                  if (c.accept) {
                    insurancePax++
                  }
                }
                depostTxt.push(
                  ' a ' +
                    priceFormat(this.odata.currency, insurance_payment, ',', 2, 1) +
                    ' total for ' +
                    insurancePax +
                    ' travelers’ protection plan' +
                    (insurancePax > 1 ? 's' : '') +
                    ' (including taxes and fees)'
                )
              }
              if (opt_deposit >= 0) {                
                if (this.opt_policy_deposit.common > 0) {
                  depostTxt.push(
                    ' a ' +
                      priceFormat(this.odata.currency, this.opt_policy_deposit.common, ',', 2, 1) +
                      ' deposit for ' +
                      optPax.length +
                      ' traveler' +
                      (optPax.length > 1 ? 's' : '') +
                      '\' selected additional features'
                  )
                }
                for (let optpolicy of this.opt_policy_deposit.policy) {
                  depostTxt.push(
                    ' a ' +
                      priceFormat(this.odata.currency, optpolicy.amt, ',', 2, 1) +
                      ' deposit for ' +
                      optpolicy.qty +
                      ' traveler' +
                      (optpolicy.qty > 1 ? 's' : '') +
                      '\' selected ' +
                      optpolicy.optname
                  )
                }
              }
 
              if (trip_depost >= 0) {
                depostTxt.push(
                  ' a ' +
                    priceFormat(this.odata.currency, trip_depost / this.persons, ',', 2, 1) +
                    ' per person deposit for the land portion'
                )
              }
              if (depostTxt.length > 1) {
                depostTxt[depostTxt.length - 1] = ' and ' + depostTxt[depostTxt.length - 1]
              }
              price = oTotal > price ? price : oTotal
              finalprice -= parseFloat(price)
              deposit =
                price >= 0
                  ? {
                      title: 'Today you pay',
                      payment_date: '',
                      price: price,
                      price_format: priceFormat(this.odata.currency, price, ',', 2, 1),
                      explain: explainTxt + depostTxt.join(','),
                      policy: 1
                    }
                  : {}
            }
            else if (2 == ridx) {
              price =
                rs.trip[2].type == 1
                  ? (oTotal * rs.trip[2].rate) / 100
                  : rs.trip[2].rate * this.persons * this.depositCurrencyRate()
              //price = oTotal > price?price:oTotal;
              finalprice -= parseFloat(price)
              secondpayment =
                price > 0
                  ? {
                      title: 'Second Payment',
                      payment_date: this.flyWeekMDate(
                        new Date().nextDate(rs.trip[2].date).getFullstring()
                      ),
                      price: price,
                      price_format: priceFormat(this.odata.currency, price, ',', 2, 1),
                      explain: '',
                      policy: 0
                    }
                  : {}
            } else if (3 == ridx && rs.trip[3].triggerdays) {
              beforedate = rs.trip[3].triggerdays
            }
          }
        }
        let fpdate = new Date(this.odata.depart_date + 'T00:00:01')
          .nextDate(-(beforedate * 1 - 1))
          .getFullstring()
        let today = new Date().nextDate(1).getFullstring()
        fpdate = fpdate < today ? today : fpdate

        finalpayment =
          finalprice > 0
            ? {
                title: notEmpty(deposit) ? 'Balance Due' : 'Today you pay',
                payment_date: notEmpty(deposit) ? this.flyWeekMDate(fpdate) : '',
                price: finalprice,
                price_format: priceFormat(this.odata.currency, finalprice, ',', 2, 1),
                explain: notEmpty(deposit) ? '' : explainTxt + this.fullAmtTxt(),
                policy: notEmpty(deposit) ? 0 : 1
              }
            : {}

        const selectedPaymentType = this.getSelectedPaymentType()
        const isFullAmount = selectedPaymentType === 'full amount'
        const isDepositAmount = selectedPaymentType === 'deposit amount'

        if (isFullAmount) {
          this.depinfo = {
            deposit: {
              title: 'Today you pay',
              payment_date: '',
              price: oTotal,
              price_format: priceFormat(this.odata.currency, oTotal, ',', 2, 1),
              explain: explainTxt + this.fullAmtTxt(),
              policy: 1
            },
            secondpayment: {},
            finalpayment: {}
          }
        } else if (isDepositAmount || notEmpty(deposit)) {
          this.depinfo = {
            deposit,
            secondpayment,
            finalpayment
          }
        } else {
          this.depinfo = {
            deposit: {},
            secondpayment,
            finalpayment
          }
        }
        this.applyChargeAmount()
        // console.log('---------------payment Summarray----',this.depinfo);
      }
    },
    // "Today you pay" shows what the gateway really charges (deposit rules, TBA flight deposit, options and
    // insurance are computed by the server): the local estimate above missed parts of it, e.g. a TBA flight
    // deposit. Only when the charge is in the page currency; the balance moves by the same difference.
    applyChargeAmount() {
      const charge = parseFloat(this.chargeAmount?.amount)
      const chargeCurrency = String(this.chargeAmount?.currency || '').toUpperCase()
      if (!(charge > 0) || chargeCurrency !== String(this.odata?.currency || '').toUpperCase()) return
      const today = notEmpty(this.depinfo.deposit) ? this.depinfo.deposit : this.depinfo.finalpayment
      if (!notEmpty(today) || today.title !== 'Today you pay') return
      const delta = charge - parseFloat(today.price || 0)
      if (Math.abs(delta) < 0.01) return
      today.price = charge
      today.price_format = priceFormat(this.odata.currency, charge, ',', 2, 1)
      const balance = this.depinfo.finalpayment
      if (today !== balance && notEmpty(balance)) {
        const rest = parseFloat(balance.price || 0) - delta
        if (rest > 0.009) {
          balance.price = rest
          balance.price_format = priceFormat(this.odata.currency, rest, ',', 2, 1)
        } else {
          this.depinfo.finalpayment = {}
        }
      }
    },
    // Product currency -> page currency rate for fixed deposit amounts (1 when they are the same).
    depositCurrencyRate() {
      const rate = Number(this.odata?.pageCurrencyRate)
      if (Number.isFinite(rate) && rate > 0) return rate
      // pageCurrencyRate can be missing from the stored order data: derive page / product from the currency list
      // (values are relative to the base currency).
      const list = useCurrencyStore().currencyList ?? []
      const pageCur = list.find((c) => c.code === this.odata?.currency)
      const productCur = list.find((c) => c.code === this.odata?.product_info?.currency)
      return pageCur && productCur && productCur.value > 0 ? pageCur.value / productCur.value : 1
    },
    tripDeposit(trip_depost,opt_deposit,packageFlyamt=0)
    {
      let price= 0;
      let trip_total = parseFloat(this.priceSummary?.roomprice?.price??0) - packageFlyamt
      let soloprice  = 0
      for (let detail of (this.priceSummary?.roompriceDetails??[])) {
        if (detail.title == 'Solo Occupancy') {
           soloprice += parseFloat(detail.price);
        }
      }
      let trip_discounts = 0;
      for(let dc of this.discounts){
        if(dc.title.includes('Groupon')){
          trip_discounts += parseFloat(this.odata.prices_info[this.odata.depart_date].price)
        }
        else if(dc.type!=20){
          trip_discounts -= parseFloat(dc.price)
        }
      }
      if(trip_discounts > (trip_total - soloprice) )
      {
        trip_depost = 0;
      }
      else{
        trip_depost = trip_depost > (trip_total-soloprice-trip_discounts)?(trip_total-soloprice-trip_discounts):trip_depost
      }
      for(let optitem of this.priceSummary?.options??[]){
        trip_total+= parseFloat(optitem?.price??0)
      }
      price = trip_depost + opt_deposit 
      if(price>(trip_total-trip_discounts))
      {
        price = (trip_total-trip_discounts)>0?(trip_total-trip_discounts):0;
      }
      return price
    },
    fullAmtTxt(){
      let res = []
      //flight price
      this.opt_policy_deposit = { common: 0, policy: [] }
      if (notEmpty(this.priceSummary)) {
        if (this.odata.isFlight > 0) {
          let fly_deposit =
            this.odata.flights_amount > 0
              ? parseFloat(this.odata.flights_amount)
              : parseFloat(this.odata.cityprice) * this.persons
          for(let dc of this.discounts){
            if(dc.title.includes('Groupon')){
              fly_deposit += (dc.price + this.odata.prices_info[this.odata.depart_date].price)
            }
          } 
          if (fly_deposit > 0) {
            //$XXX.00 per-person for airfare (including taxes and fees)
            res.push(
              priceFormat(this.odata.currency, fly_deposit / this.persons, ',', 2, 1) +
                ' per-person for airfare (including taxes and fees)'
            )
          }
        }
        if (notEmpty(this.priceSummary.insurance) && this.priceSummary.insurance.price > 0) {
          //$XXX.00 total for xx travelers’ protection plan,
          let insurancePax = 0
          for (let c of this.insuranceStore.quoteInfo.customers) {
            if (c.accept) {
              insurancePax++
            }
          }
          const insuranceText = `${this.priceSummary.insurance.format} total for ${insurancePax} traveler${insurancePax > 1 ? 's' : ''}’ protection plan${insurancePax > 1 ? 's' : ''}`
          res.push(insuranceText)
        }
        if (notEmpty(this.priceSummary.options)) {
          //let opt_deposit = 0;
          let optPax = []
          for (let povid in this.odata.options) {
            if (notEmpty(this.povOptions[povid]) && this.povOptions[povid].price > 0) {
              let optAmt =
                parseFloat(this.povOptions[povid].price) * this.odata.options[povid].length
              if (this.povOptions[povid].policy > 0) {
                this.opt_policy_deposit.policy.push({
                  povid: povid,
                  amt: optAmt,
                  qty: this.odata.options[povid].length,
                  optname: this.povOptions[povid].name
                })
              } else {
                this.opt_policy_deposit.common += optAmt
                // opt_deposit += optAmt;
                for (let t of this.odata.options[povid]) {
                  if (!optPax.includes(t)) {
                    optPax.push(t)
                  }
                }
              }
            }
          }
          if (this.opt_policy_deposit.common > 0) {
            res.push(
              ' a ' +
                priceFormat(this.odata.currency, this.opt_policy_deposit.common, ',', 2, 1) +
                ' total for ' +
                optPax.length +
                ' traveler' +
                (optPax.length > 1 ? 's' : '') +
                '’ selected additional features'
            )
          }
          for (let optpolicy of this.opt_policy_deposit.policy) {
            res.push(
              ' a ' +
                priceFormat(this.odata.currency, optpolicy.amt, ',', 2, 1) +
                ' total for ' +
                optpolicy.qty +
                ' traveler' +
                (optpolicy.qty > 1 ? 's' : '') +
                '’ selected ' +
                optpolicy.optname
            )
          }

          // if (optprice > 0) {

          //   //a $xxx.00 total for xx travelers’ selected additional features
          //   res.push('a ' + priceFormat(this.odata.currency, optprice, ',',2,1) + ' total for '+optPax.length+' traveler'+(optPax.length>1?'s':'')+'’ selected additional features');
          //   //res.push('a ' + priceFormat(this.odata.currency, optprice, ',') + ' total for selected additional features');
          // }
        }
        if (this.priceSummary.roomprice.price > 0) {
          let rmprice = parseFloat(this.priceSummary.roomprice.price)
          if (this.odata.product_info.model.toUpperCase().slice(0, 3) == 'FP-') {
            rmprice -= parseFloat(this.odata.cityprice) * this.persons
          }
          // $XXX.00 total for xx travelers of the land portion.
          res.push(
            priceFormat(this.odata.currency, rmprice, ',', 2, 1) +
              ' total for ' +
              this.persons +
              ' traveler' +
              (this.persons > 1 ? 's' : '') +
              ' of the land portion.'
          )
        }

        if (notEmpty(this.priceSummary.discounts)) {
          let pointprice = 0
          let couponprice = 0
          for (let item of this.priceSummary.discounts) {
            if ('Points' == item.title) {
              pointprice += parseFloat(item.price)
            } else {
              couponprice += parseFloat(item.price)
            }
          }
          if (couponprice > 0) {
            res.push(priceFormat(this.odata.currency, couponprice, ',', 2, 1) + ' Coupon discount')
          }
          if (pointprice > 0) {
            res.push(priceFormat(this.odata.currency, pointprice, ',', 2, 1) + ' Point discount')
          }
        }
      }
      if (res.length > 0) {
        if (res.length > 1) {
          res[res.length - 1] = ' and ' + res[res.length - 1]
        }
        return res.join(',')
      }
      return ''
    },
    flyWeekMDate(d, y = 1) {
      var dt = new Date(d)
      var weeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      var months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ]
      var formattedDate =
        weeks[dt.getDay()] +
        ', ' +
        months[dt.getMonth()] +
        ' ' +
        dt.getDate() +
        ',' +
        (y > 0 ? ' ' + dt.getFullYear() : '')
      return formattedDate
    }
  }
}
</script>

<style scoped>
.pop_con {
  margin-top: 3rem;

  overflow-y: auto;
  /*   height: 65vh; */
  max-height: 73vh;
}

:deep(.product_policy_detail h2) {
  margin-top: 2rem !important;
}

.product_policy {
  overflow-y: auto;

  font-size: 1.4rem;
}

.product_policy ol {
  padding-bottom: 1rem;
  padding-left: 2rem;
}

.product_policy .name {
  text-align: center;
  font-weight: bold;
  font-size: 1.7rem;
}

.product_policy_detail {
  /*  height:10rem;overflow-y: auto;border:1px solid #ccc;border-radius:10px; */
  /*  */
  margin-top: 1rem;
  padding: 2rem !important;
}

:deep(.product_policy_detail ol) {
  padding-left: 2rem;
}

.policy_title {
  font-weight: bold;
  font-size: 1.9rem;
  text-align: center;
}

.totalbox {
  padding: 0 2.4rem;
  border-radius: 1.2rem;
  margin-bottom: 3.4rem;
  background: #fff;
}

.totalbox .titbox {
  padding-top: 2rem;
  color: #333;
  font-family: Poppins-Bold;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 2.2rem;
}

.totalbox .infobox {
  padding: 1.6rem 0 2.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
}

.totalbox .infobox .pic {
  width: 8rem;
  height: 7rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 0.8rem;
}

.totalbox .infobox .txt {
  width: calc(100% - 9.2rem);
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2rem;
  text-align: left;
}

.totalbox .listbox {
  padding: 1.2rem 0;
  border-bottom: 1px solid #eaeaea;
}

.totalbox .listbox:last-child {
  border-bottom: 0;
}

.totalbox .listbox .tit {
  font-family: Poppins-Bold;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 2rem;
  padding: 0.8rem 0;
}

.totalbox .listbox .row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2rem;
  padding: 0.8rem 0;
}

.totalbox .listbox .row.total {
  font-size: 1.6rem;
  font-family: Poppins-Bold;
  font-weight: 700;
}

.totalbox .listbox .row.price-emphasis {
  font-size: 1.6rem;
  font-family: Poppins-Bold;
  font-weight: 700;
  line-height: 2.2rem;
}

.totalbox .listbox .row.balance-due-row {
  align-items: center;
  font-size: 1.4rem;
  line-height: 2rem;
  padding-top: 1.2rem;
}

.totalbox .listbox .row.balance-due-row .label {
  color: #333333;
  font-family: Poppins-Bold;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 2rem;
}

.totalbox .listbox .row.balance-due-row .contxt {
  color: #333333;
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2rem;
}

.totalbox .listbox .row .label {
  color: #666666;
  word-break: break-word;
  white-space: normal; 
}

.totalbox .listbox .row .airico {
  width: 2rem;
  display: block;
}

.totalbox .listbox .row.total .label,
.totalbox .listbox .row.price-emphasis .label,
.totalbox .listbox .row .label span.black,
.totalbox .listbox .row .contxt {
  color: #333333;
}

.totalbox .listbox .row.price-emphasis .contxt {
  color: #333333;
}

.totalbox .listbox .row {
    .onerow {
      white-space: nowrap; 
    } 
  }

.totalbox .listbox .row .green {
  color: #4f6f52 !important;
}

.totalbox .listbox .contxt span {
  color: #1b80de;
  cursor: pointer;
}

.totalbox .listbox .contxt .ico {
  width: 2rem;
  display: inline-block;
}

.prop .airfaretipscon {
  padding: 2.4rem;
  font-family: Poppins;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 2.4rem;
  text-align: left;
  color: #333;
  max-width: 66rem;
  height: auto;
  max-height: 80vh !important;
}

.prop .airfaretipscon p {
  padding-left: 2.4rem;
  position: relative;
}

.prop .airfaretipscon p::before {
  content: '';
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: #333;
  position: absolute;
  top: 1rem;
  left: 1rem;
}

.click {
  font-size: 1.3rem !important;
}

.click span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.prop {
  z-index: 999999 !important;
}

.prop .con {
  /*  overflow-y: auto !important; */
  width: 90% !important;
}

/* 移动端  */
@media screen and (max-width: 750px) {
  .prop .con .fixed_closer {
    top: 0rem !important;
  }

  .pop_con {
    height: 65vh;
  }
  .prop {
    z-index: 999999 !important;
  }

  .prop .con {
    position: absolute;
    box-sizing: border-box;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 2rem;
    box-shadow: 0px 10px 60px -10px #00000014;
    height: 90%;
    /* 保证上下各留5%空间 */
    /*  overflow: auto; */
    /* 内容溢出时出现滚动条 */
    /*     overflow-y: auto !important; */
    width: 90% !important;
  }

  .prop .airfaretipscon {
    padding: 0.4rem;
  }

  .product_policy .name {
    text-align: center;
    font-weight: bold;
    font-size: 1.4rem;
  }

  .product_policy_detail {
    /*   height:10rem;overflow-y: auto;border:1px solid #ccc;border-radius:10px; */
    padding: 1rem !important;
  }

  :deep(.product_policy_detail ol) {
    padding-left: 2rem;
  }

  .click {
    font-size: 1.3rem !important;
  }

  .totalbox {
    margin-bottom: 7rem;
  }
}
</style>
